export default __webpack_public_path__ + "static/superstructure_w.2b7c4f6b59ec2d19c4c3141ef95ce73a.svg";